import { NotifyHelper } from 'classes/helpers/notify.helper';
import { CommonDialog } from 'components/common/dialogs';
import { CommonFormGrid } from 'components/common/form/grid';
import { CommonSearchInput } from 'components/common/form/search';
import { CommonSelectInput } from 'components/common/form/select';
import { IBaseDialog } from 'interfaces/i-dialogs';
import { ArrayHelper } from 'lib_ts/classes/array.helper';
import { MlbSportId } from 'lib_ts/enums/mlb-stats-api/base.enum';
import { MlbEntity } from 'lib_ts/enums/mlb-stats-api/entities.enum';
import { RADIX } from 'lib_ts/enums/radix-ui';
import { IMlbImportRequest } from 'lib_ts/interfaces/mlb-stats-api/i-import-request';
import { useState } from 'react';
import { MlbStatsService } from 'services/mlb-stats.service';

const SEASON_OPTIONS = ArrayHelper.getIntegerOptions(
  2020,
  new Date().getFullYear()
);

export const GameDataImportDialog = (props: IBaseDialog) => {
  const [request, setRequest] = useState<IMlbImportRequest>({
    seasons: [new Date().getFullYear()],
    sportIds: [MlbSportId.MLB],
    entities: [],
    force: false,
  });

  return (
    <CommonDialog
      identifier="GameDataImportDialog"
      title="Game Data Import Request"
      width={RADIX.DIALOG.WIDTH.SM}
      content={
        <CommonFormGrid columns={1}>
          <CommonSearchInput
            id="gd-import-seasons"
            label="Seasons"
            values={request.seasons.map((s) => s.toFixed(0))}
            options={SEASON_OPTIONS}
            onChange={(values) =>
              setRequest((prev) => ({
                ...prev,
                seasons: values.map((s) => parseInt(s)),
              }))
            }
            multiple
          />
          <CommonSearchInput
            id="gd-import-sports"
            label="Leagues"
            values={request.sportIds.map((id) => id.toFixed(0))}
            options={[
              {
                label: 'MLB',
                value: MlbSportId.MLB.toFixed(0),
              },
              {
                label: 'AAA',
                value: MlbSportId.AAA.toFixed(0),
              },
            ]}
            onChange={(values) =>
              setRequest((prev) => ({
                ...prev,
                sportIds: values.map((s) => parseInt(s)),
              }))
            }
            multiple
          />
          <CommonSearchInput
            id="gd-import-entities"
            label="Entities"
            values={request.entities}
            options={Object.values(MlbEntity).map((o) => ({
              label: o,
              value: o,
            }))}
            onChange={(values) =>
              setRequest((prev) => ({
                ...prev,
                entities: values as MlbEntity[],
              }))
            }
            multiple
          />
          <CommonSelectInput
            id="gd-import-force"
            label="Force"
            value={request.force.toString()}
            options={[
              {
                label: 'Yes',
                value: 'true',
              },
              {
                label: 'No',
                value: 'false',
              },
            ]}
            onBooleanChange={(v) =>
              setRequest((prev) => ({
                ...prev,
                force: v,
              }))
            }
          />
        </CommonFormGrid>
      }
      buttons={[
        {
          label: 'Submit',
          onClick: () => {
            MlbStatsService.getInstance().importRequest(request);

            NotifyHelper.success({
              message_md: 'Import request sent!',
            });

            props.onClose();
          },
        },
      ]}
      onClose={props.onClose}
    />
  );
};
